import React from 'react';
import '../styles.css';

export default function FAQ() {
  return (
    <section className="faq">
      <h2>FAQ</h2>
      <div className="faq__item">
        <h3>How do I invite friends?</h3>
        <p>Click “Invite” in the dashboard and share the link. They can then upload directly.</p>
      </div>
      <div className="faq__item">
        <h3>What formats are supported?</h3>
        <p>JPEG, PNG, HEIC, MP4, MOV; with automatic GIF thumbnail generation.</p>
      </div>
      <div className="faq__item">
        <h3>How does the AI learn?</h3>
        <p>Every upload and swipe trains the on-device model to surface your best moments.</p>
      </div>
      <div className="faq__item">
        <h3>Can I add voice notes?</h3>
        <p>Yes, press the 🎙️ button during playback to record captions.</p>
      </div>
    </section>
  );
}
